import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrCard, {
  SR_CARD_BULLET_COLOR_PURPLE,
  SR_CARD_CONTENT_TYPE_FORM_GRID,
} from 'client/components/SrCard/SrCard';
import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import SrText from 'client/components/SrText';

const UPUtilityConfirmationEmailForm = ({ formikBag, formField }) => (
  <SrCard
    color={SR_CARD_BULLET_COLOR_PURPLE}
    contentType={SR_CARD_CONTENT_TYPE_FORM_GRID}
    headerFlexDirection="column"
    header="Utility confirmation email"
    subheader="Where we send utility setup confirmations for your properties."
  >
    <SrBox width="600px" marginTop="12px" marginLeft="35px">
      <SrFormikField
        formField={{
          ...formField,
          properties: {
            ...formField.properties,
            widget: (
              <>
                {!formikBag.values.utilityConfirmationEmail && (
                  <SrBox marginTop="8px">
                    <SrText font="greycliff" weight="600" size="14" color="orange300">
                      No confirmation email set — you won&apos;t receive utility setup confirmations
                      until you add one.
                    </SrText>
                  </SrBox>
                )}
                <SrBox marginTop="8px">
                  <SrText font="greycliff" weight="500" size="14" color="grey600">
                    You can adjust confirmation email addresses for individual properties in the
                    Synced Listings section.
                  </SrText>
                </SrBox>
              </>
            ),
          },
        }}
        formikBag={formikBag}
        theme={SR_FIELD_THEME_ADOBE}
      />
    </SrBox>
  </SrCard>
);

UPUtilityConfirmationEmailForm.propTypes = {
  formikBag: PropTypes.object.isRequired,
  formField: PropTypes.object.isRequired,
};

UPUtilityConfirmationEmailForm.displayName = 'UPUtilityConfirmationEmailForm';

export default UPUtilityConfirmationEmailForm;
